import { LinkProvider } from '@wrenpages/design-system';
import { RouterProvider, type DataRouter } from 'react-router';
import { RouterLinkAdapter } from './providers/RouterLinkAdapter';

export function App({ router }: { router: DataRouter }) {
  return (
    <LinkProvider component={RouterLinkAdapter}>
      <RouterProvider router={router} />
    </LinkProvider>
  );
}
